import { authorizedApiRequest } from './ApiRequest';
import { surveyService } from './SurveyService';
import { contentService } from './contentService';

export const services = {
  surveys: surveyService,
  content: contentService,
};

